module.exports = __webpack_public_path__ + "img/intruduce-title.e38f60f0.png";